import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { ModalClose } from 'client/components/Helpers/Modal';
import propTypes from 'prop-types';
import NewsEditPanel from 'client/components/News/NewsEditPanel';

export default class NewsEditModal extends Component {

  static defaultProps = {
    open: false,
  };

  static propTypes = {
    open: propTypes.bool,
    onClose: propTypes.func.isRequired,
    onNewsWasUpdated: propTypes.func,
    newsItem: propTypes.object.isRequired,
  };

  onSave = () => {
    this.props.onClose();
    this.props.onNewsWasUpdated();
  };

  render () {
    const { onClose, open, newsItem } = this.props;
    return (
      <Modal dialogClassName="colored-header colored-header-primary" show={open} onHide={onClose} backdrop="static">
        <Modal.Header className="modal-header">
          <ModalClose onClose={onClose} />
          <Modal.Title>Edit News Item</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {open && <NewsEditPanel newsItem={newsItem} onSave={this.onSave} />}
        </Modal.Body>
      </Modal>
    );
  }

}
